import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_EMERGENCY_DTRF_LIST,
    getEmergencyDtrfListFail,
    getEmergencyDtrfListSuccess
} from '../action/getEmergencyDtrfListAction'

// api 
import getEmergencyDtrfListApi from '../api/getEmergencyDtrfListApi'

export function* getEmergencyDtrfListSaga(action) {
    try {
        const response = yield call(() => getEmergencyDtrfListApi(action.params))
        if (response.data.statusCode === 200) {
            yield put(getEmergencyDtrfListSuccess(response, action))
        } else {
            yield put(getEmergencyDtrfListFail(response, action))
        }
    }
    catch (e) {
        yield put(getEmergencyDtrfListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_EMERGENCY_DTRF_LIST, getEmergencyDtrfListSaga)
}